/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ReportviewImport } from './routes/reportview'
import { Route as IndexImport } from './routes/index'

// Create/Update Routes

const ReportviewRoute = ReportviewImport.update({
  id: '/reportview',
  path: '/reportview',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/reportview': {
      id: '/reportview'
      path: '/reportview'
      fullPath: '/reportview'
      preLoaderRoute: typeof ReportviewImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/reportview': typeof ReportviewRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/reportview': typeof ReportviewRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/reportview': typeof ReportviewRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/reportview'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/reportview'
  id: '__root__' | '/' | '/reportview'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ReportviewRoute: typeof ReportviewRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ReportviewRoute: ReportviewRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/reportview"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/reportview": {
      "filePath": "reportview.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
